var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { trim, includes } from 'lodash'; // import {
//   classNames,
//   useMainMenu,
//   MenuItemLink,
//   useIcons,
//   useLang,
//   useLink,
//   useSite,
//   Icon,
//   useActiveEntity,
//   IS_LANG_ENABLED,
//   MenuCircleIcon,
//   SearchCircleIcon,
//   GlobeCircleIcon,
//   ShareCircleIcon,
//   SliceLayoutBoundaryVariant,
//   SliceLayout,
//   usePlatformUrl,
//   PersonCircleIcon,
//   useActiveLang,
//   useSiteHeader, 
//   HeaderUtilityButton,
//   LangMenu,
//   SiteMenuBar,
//   ShareMenu,
//   useModal,
//   useSiteSidebar,
//   useMapUtils,
//   MenuReveal,
//   SiteHeaderLogo,
//   HeaderUtilityButtonVariant,
//   useInViewEffect,
// } from '@shapeable/web';
// @ts-ignore

import SITE_HEADER_LAYOUT_BG from '../../images/site-header-layout-bg.png';
import { NavigationMenu } from '../elements/navigation-menu';
import { SiteMenuBar } from './site-menu-bar';
import { classNames } from '../../utils/cn';
import { SliceLayout } from './slice-layout';
import { HeaderUtilityButton } from '../elements/header-utility-button';
import { useMainMenu } from '../../hooks/use-main-menu';
import { MenuItemLink } from './menu-item-link';
import { ShareMenu } from '../elements/share-menu';
import { useIcons } from '../../hooks/use-icons';
import { useLang } from '../../hooks/use-lang';
import { useLink } from '../../hooks/use-link';
import { useSite } from '../../hooks/use-site';
import { Icon } from '../elements/icon';
import { useActiveEntity } from '../../hooks/use-active-entity';
import { IS_LANG_ENABLED } from '../../constants';
import { SearchCircleIcon } from '../elements/search-circle-icon';
import { MenuCircleIcon } from '../elements/menu-circle-icon';
import { ShareCircleIcon } from '../elements/share-circle-icon';
import { GlobeCircleIcon } from '../elements/globe-circle-icon';
import { usePlatformUrl } from '../../hooks/use-platform-url';
import { PersonCircleIcon } from '../elements/person-circle-icon';
import { LangMenu } from '../elements/lang-menu';
import { useActiveLang } from '../../hooks/use-active-lang';
import { SiteHeaderLogo } from './site-header-logo';
import { MenuReveal } from '../elements/menu-reveal';
import { useSiteHeader } from '../../hooks/use-site-header';
import { useModal } from '../../hooks/use-modal';
import { useSiteSidebar } from '../../hooks/use-site-sidebar';
import { useMapUtils } from '../../hooks/use-map-state';
import { TextBubble } from '../elements/text-bubble';
var cls = classNames('site-header-layout');
export var SiteHeaderLayoutDefaultProps = {
  variant: 'overlay',
  boundary: 'content',
  showOverlayGradient: true,
  useLogoVerticalOffsets: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    font-weight: 500;\n    font-size: ", ";\n\n    .shp--slice-layout {\n      flex-grow: 1;\n    }\n\n    .shp--slice-layout__boundary {\n      height: 100%;\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    font-weight: 500;\n    font-size: ", ";\n\n    .shp--slice-layout {\n      flex-grow: 1;\n    }\n\n    .shp--slice-layout__boundary {\n      height: 100%;\n    }\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var heightMobile = _a.heightMobile;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightMobile);
  }, theme.FONT_SIZE(15), function (_a) {
    var _backgroundColor = _a._backgroundColor;
    return _backgroundColor && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color ", ";\n    "], ["\n      background-color ", ";\n    "])), theme.COLOR(_backgroundColor));
  }, function (_a) {
    var showOverlayGradient = _a.showOverlayGradient;
    return showOverlayGradient && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-image: url(", ");\n      background-repeat: repeat-x;\n      background-position: bottom left;\n    "], ["\n      background-image: url(", ");\n      background-repeat: repeat-x;\n      background-position: bottom left;\n    "])), SITE_HEADER_LAYOUT_BG);
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightTablet = _a.heightTablet;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightTablet);
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightDesktop = _a.heightDesktop;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightDesktop);
  })
});
var LayoutStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    flex-direction: row;\n    align-self: stretch;\n    justify-self: stretch;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    flex-direction: row;\n    align-self: stretch;\n    justify-self: stretch;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n    justify-content: space-between;\n  "])))
});
var NavigationAndControlsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: none;\n    width: 100%;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n\n    ", "\n\n    box-sizing: border-box;\n  "], ["\n    display: none;\n    width: 100%;\n    flex-grow: 1;\n    align-self: stretch;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n\n    ", "\n\n    box-sizing: border-box;\n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      /* this area needs to be more centrally aligned when the nav is not an overlay, otherwise it looks a bit \"off\" */\n      padding-top: ", ";\n    "], ["\n      /* this area needs to be more centrally aligned when the nav is not an overlay, otherwise it looks a bit \"off\" */\n      padding-top: ", ";\n    "])), theme.UNIT(variant === 'overlay' ? 4 : 2.5));
  }),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var NavigationStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-size: 1em;\n    list-style: none;\n    margin: 0;\n    display: none;\n    align-self: stretch;\n    height: 100%;\n    padding-left: ", ";\n  "], ["\n    font-size: 1em;\n    list-style: none;\n    margin: 0;\n    display: none;\n    align-self: stretch;\n    height: 100%;\n    padding-left: ", ";\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
});
var NavigationItemStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: 0 ", ";\n    position: relative;\n  "], ["\n    padding: 0 ", ";\n    position: relative;\n  "])), theme.UNIT(1.5))
});
var MenuItemLinkStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n  "], ["\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n  "])), function (_a) {
    var isDisclosed = _a.isDisclosed;
    return css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      .shp--icon {\n        margin-top: -2px;\n        transition: transform 0.2s ease-in-out;\n        transform: rotate(", ");\n      }\n    "], ["\n      .shp--icon {\n        margin-top: -2px;\n        transition: transform 0.2s ease-in-out;\n        transform: rotate(", ");\n      }\n    "])), isDisclosed ? '180deg' : '0deg');
  })
});
var MenuItemSubLinkStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NavigationItemChildrenStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    position: absolute;\n    left: -2px;\n    top: 44px;\n    margin: 0;\n    list-style: none;\n    padding: ", " ", " ", " ", ";\n    background: rgba(0,0,0,0.7);\n    z-index: 100;\n    border-radius: ", ";\n  "], ["\n    position: absolute;\n    left: -2px;\n    top: 44px;\n    margin: 0;\n    list-style: none;\n    padding: ", " ", " ", " ", ";\n    background: rgba(0,0,0,0.7);\n    z-index: 100;\n    border-radius: ", ";\n  "])), theme.UNIT(4), theme.UNIT(2.5), theme.UNIT(5), theme.UNIT(2.5), theme.UNIT(2))
});
var MenuItemLinkChildStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    width: 100%;\n    font-weight: 300;\n    width: 200px;\n    display: block;\n    text-shadow: 0 1px 0 rgba(0,0,0,0.3);\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    margin: 0 0 ", " 0;\n    width: 100%;\n    font-weight: 300;\n    width: 200px;\n    display: block;\n    text-shadow: 0 1px 0 rgba(0,0,0,0.3);\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme.UNIT(4))
});
var MenuButtonStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    ", ";\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n    display: none;\n    margin-left: ", ";\n    display: block;\n\n    ", "\n  "], ["\n    ", ";\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n    display: none;\n    margin-left: ", ";\n    display: block;\n\n    ", "\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(3), function (_a) {
    var _color = _a._color,
        _hoverColor = _a._hoverColor;
    return css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      ", ";\n\n      &:hover {\n        ", ";\n      }\n    "], ["\n      ", ";\n\n      &:hover {\n        ", ";\n      }\n    "])), theme.FILL(_color), theme.FILL(_hoverColor));
  }),
  tablet: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n    display: block;\n\n  "], ["\n    width: 32px;\n    height: 32px;\n    display: block;\n\n  "])))
});
var SearchButtonStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    ", ";\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n  "], ["\n    ", ";\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n  "])), theme.REMOVE_BUTTON_STYLE()),
  tablet: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n  "], ["\n    width: 32px;\n    height: 32px;\n  "]))),
  desktop: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n  "], ["\n    width: 32px;\n    height: 32px;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    ", ";\n\n    &:hover {\n      \n      ", "\n\n\n    }\n  "], ["\n    ", ";\n\n    &:hover {\n      \n      ", "\n\n\n    }\n  "])), theme.FILL('#FFF'), function (_a) {
    var menuLinkActiveColor = _a.menuLinkActiveColor;
    return css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n        ", ";\n      "], ["\n        ", ";\n      "])), theme.FILL(menuLinkActiveColor));
  })
});
var UtilityButtonsStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    display: none;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    height: 32px;\n    align-self: flex-end;\n  "], ["\n    display: none;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    height: 32px;\n    align-self: flex-end;\n  "]))),
  desktop: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var MenuButtonsStyles = breakpoints({
  base: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    align-self: flex-end;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    position: relative;\n  "], ["\n    align-self: flex-end;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    position: relative;\n  "]))),
  tablet: css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var UtilityButtonStyles = breakpoints({
  base: css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    margin-left: ", ";\n    position: relative;\n    &:first-child {\n      margin-left: 0;\n    }\n  "], ["\n    margin-left: ", ";\n    position: relative;\n    &:first-child {\n      margin-left: 0;\n    }\n  "])), theme.UNIT(2))
});
var LangUtilityButtonStyles = breakpoints({
  base: css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    ", ";\n    ", ",\n    ", " {\n      width: 72px; \n    }\n  "], ["\n    ", ";\n    ", ",\n    ", " {\n      width: 72px; \n    }\n  "])), UtilityButtonStyles, HeaderUtilityButton.cls.dot('button'), HeaderUtilityButton.cls.dot('menu-button'))
});
var HeadEndStyles = breakpoints({
  base: css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    position: relative;\n\n  "], ["\n    position: relative;\n\n  "])))
});
var ShareMenuStyles = breakpoints({
  base: css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    box-sizing: border-box;\n    overflow: auto;\n  "], ["\n    box-sizing: border-box;\n    overflow: auto;\n  "])))
});
var LangMenuRevealStyles = breakpoints({
  base: css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ShareMenuRevealStyles = breakpoints({
  base: css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var NavigationMenuRevealStyles = breakpoints({
  base: css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var NavigationMenuStyles = breakpoints({
  base: css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    padding: ", " 0 0;\n    font-size: 1em;\n    list-style: none;\n    z-index: 100;\n    margin: 0;\n    min-width: 300px;\n  "], ["\n    padding: ", " 0 0;\n    font-size: 1em;\n    list-style: none;\n    z-index: 100;\n    margin: 0;\n    min-width: 300px;\n  "])), theme.UNIT(1))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LangMenuStyles = breakpoints({
  base: css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MenuBarStyles = breakpoints({
  base: css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    position: fixed;\n    top: -100px;\n    z-index: 300;\n    left: 0;\n    transition: top 0.3s;\n    box-shadow: 0 1px 4px -3px rgba(0,0,0,0.7);\n    \n\n    ", "\n  "], ["\n    position: fixed;\n    top: -100px;\n    z-index: 300;\n    left: 0;\n    transition: top 0.3s;\n    box-shadow: 0 1px 4px -3px rgba(0,0,0,0.7);\n    \n\n    ", "\n  "])), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n      top: 0;\n    "], ["\n      top: 0;\n    "])));
  })
});
var LangMenuButtonStyles = breakpoints({
  base: css(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n    cursor: pointer;\n    ", "\n  "], ["\n    cursor: pointer;\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
        _hoverColor = _a._hoverColor,
        _textColor = _a._textColor;
    return css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n      background: ", ";\n      text-transform: uppercase;\n      color: ", ";\n      &:hover {\n        background: ", ";\n      }\n    "], ["\n      background: ", ";\n      text-transform: uppercase;\n      color: ", ";\n      &:hover {\n        background: ", ";\n      }\n    "])), _color, _textColor, _hoverColor);
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MenuBar: styled(SiteMenuBar)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), MenuBarStyles),
  Icon: styled(Icon)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Layout: styled.div(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Logo: styled(SiteHeaderLogo)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  UtilityButtons: styled.div.attrs(cls.attr('utility-buttons'))(templateObject_55 || (templateObject_55 = __makeTemplateObject(["", ""], ["", ""])), UtilityButtonsStyles),
  UtilityButton: styled(HeaderUtilityButton)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["", ""], ["", ""])), UtilityButtonStyles),
  LangUtilityButton: styled(HeaderUtilityButton)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["", ""], ["", ""])), LangUtilityButtonStyles),
  HeadEnd: styled.div.attrs(cls.attr('head-end'))(templateObject_58 || (templateObject_58 = __makeTemplateObject(["", ""], ["", ""])), HeadEndStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_59 || (templateObject_59 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  NavigationAndControls: styled.div.attrs(cls.attr('navigation-and-controls'))(templateObject_60 || (templateObject_60 = __makeTemplateObject(["", ""], ["", ""])), NavigationAndControlsStyles),
  Navigation: styled.ul.attrs(cls.attr('navigation'))(templateObject_61 || (templateObject_61 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  NavigationItem: styled.li.attrs(cls.attr('navigation-item'))(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), NavigationItemStyles),
  MenuItemLink: styled(MenuItemLink)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), MenuItemLinkStyles),
  NavigationItemChildren: styled.ul.attrs(cls.attr('navigation-item-children'))(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), NavigationItemChildrenStyles),
  NavigationItemChild: styled.li.attrs(cls.attr('navigation-item-child'))(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), MenuItemLinkChildStyles),
  MenuItemSubLink: styled(MenuItemLink)(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), MenuItemSubLinkStyles),
  Controls: styled.div.attrs(cls.attr('controls'))(templateObject_67 || (templateObject_67 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  SearchButton: styled.button.attrs(cls.attr('search-button'))(templateObject_68 || (templateObject_68 = __makeTemplateObject(["", ""], ["", ""])), SearchButtonStyles),
  LangMenuButton: styled(TextBubble).attrs(cls.attr('lang-menu-button'))(templateObject_69 || (templateObject_69 = __makeTemplateObject(["", ""], ["", ""])), LangMenuButtonStyles),
  MenuButtons: styled.div.attrs(cls.attr('menu-buttons'))(templateObject_70 || (templateObject_70 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonsStyles),
  MenuButton: styled.button.attrs(cls.attr('menu-button'))(templateObject_71 || (templateObject_71 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  ShareButton: styled.button.attrs(cls.attr('share-button'))(templateObject_72 || (templateObject_72 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  LangButton: styled.button.attrs(cls.attr('lang-button'))(templateObject_73 || (templateObject_73 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  LangMenu: styled(LangMenu)(templateObject_74 || (templateObject_74 = __makeTemplateObject(["", ""], ["", ""])), LangMenuStyles),
  ShareMenu: styled(ShareMenu)(templateObject_75 || (templateObject_75 = __makeTemplateObject(["", ""], ["", ""])), ShareMenuStyles),
  ShareMenuReveal: styled(MenuReveal)(templateObject_76 || (templateObject_76 = __makeTemplateObject(["", ""], ["", ""])), ShareMenuRevealStyles),
  LangMenuReveal: styled(MenuReveal)(templateObject_77 || (templateObject_77 = __makeTemplateObject(["", ""], ["", ""])), LangMenuRevealStyles),
  NavigationMenuReveal: styled(MenuReveal)(templateObject_78 || (templateObject_78 = __makeTemplateObject(["", ""], ["", ""])), NavigationMenuRevealStyles),
  NavigationMenu: styled(NavigationMenu)(templateObject_79 || (templateObject_79 = __makeTemplateObject(["", ""], ["", ""])), NavigationMenuStyles)
};
export var SiteHeaderLayout = function SiteHeaderLayout(props) {
  var _a;

  var className = props.className,
      variant = props.variant,
      boundary = props.boundary,
      maxLogoHeight = props.maxLogoHeight,
      activeColor = props.activeColor,
      hoverColor = props.hoverColor,
      showSearch = props.showSearch,
      showOverlayGradient = props.showOverlayGradient,
      useLogoVerticalOffsets = props.useLogoVerticalOffsets;
  var menu = useMainMenu();
  var header = useSiteHeader();
  var site = useSite();
  var modal = useModal();
  var map = useMapUtils();
  var sidebar = useSiteSidebar();
  var navigate = useLink().navigate;
  var t = useLang();
  var color = header.color,
      textColor = header.textColor,
      backgroundColor = header.backgroundColor,
      isInverted = header.isInverted,
      ref = header.ref,
      isMenuBarVisible = header.isMenuBarVisible;
  var loginLabel = site.loginLabel,
      headerHeightMobile = site.headerHeightMobile,
      headerHeightTablet = site.headerHeightTablet,
      headerHeightDesktop = site.headerHeightDesktop,
      _b = site.headerButtons,
      headerButtons = _b === void 0 ? [] : _b;
  var Icons = useIcons();
  var currentEntity = useActiveEntity();

  var sliceEntity = __assign({}, currentEntity);

  if (variant !== 'overlay') {
    sliceEntity.backgroundColor = {
      id: 'site-header-background-color',
      value: backgroundColor
    };
  }

  var activeLang = useActiveLang();
  var platformUrl = usePlatformUrl();
  var logoProps = {
    isInverted: isInverted,
    variant: isInverted ? 'inverted' : 'default',
    maxHeight: maxLogoHeight,
    useVerticalOffsets: useLogoVerticalOffsets
  }; //         <My.LangMenuButton _color={header.menuButtonColor} _hoverColor={header.menuButtonHoverColor} onClick={header.onLangButtonClick}><My.Icon><GlobeCircleIcon /></My.Icon></My.LangButton> 

  var menuButtons = React.createElement(React.Fragment, null, IS_LANG_ENABLED && React.createElement(My.LangMenuButton, {
    size: 32,
    _textColor: header.textColor,
    _color: header.menuButtonColor,
    _hoverColor: header.menuButtonHoverColor,
    onClick: header.onLangButtonClick
  }, activeLang.iso), header.showShare && React.createElement(My.ShareButton, {
    _color: header.menuButtonColor,
    _hoverColor: header.menuButtonHoverColor,
    onClick: header.onShareButtonClick
  }, React.createElement(My.Icon, null, React.createElement(ShareCircleIcon, null))), React.createElement(My.MenuButton, {
    _color: header.menuButtonColor,
    _hoverColor: header.menuButtonHoverColor,
    onClick: header.onMenuButtonClick
  }, React.createElement(My.Icon, null, React.createElement(MenuCircleIcon, null))));

  var onMenuItemClick = function onMenuItemClick(item) {
    header.setDisclosedMenuItem(item.id);
  };

  var navigationMenu = React.createElement(My.NavigationMenu, {
    onItemClick: onMenuItemClick,
    isVisible: header.isNavigationMenuVisible,
    items: header.navigationMenuItems
  });
  var pinnedNavigationMenu = React.createElement(My.NavigationMenu, {
    ref: header.pinnedNavigationMenuRef,
    onItemClick: onMenuItemClick,
    isVisible: header.isPinnedNavigationMenuVisible,
    items: header.pinnedNavigationMenuItems
  });

  var headerButtonsVariant = function headerButtonsVariant(variant) {
    var hasMenu = !(variant === 'pinned' && isMenuBarVisible || variant !== 'pinned' && !isMenuBarVisible);
    return React.createElement(React.Fragment, null, headerButtons.map(function (link) {
      var _a, _b, _c, _d, _e;

      return React.createElement(My.UtilityButton, {
        key: link.id,
        variant: variant,
        href: link.url || ((_a = link.page) === null || _a === void 0 ? void 0 : _a.path),
        backgroundColor: (_b = link.color) === null || _b === void 0 ? void 0 : _b.value,

        /* @ts-ignore */
        iconComponent: Icons[(_c = link.icon) === null || _c === void 0 ? void 0 : _c.component]
      }, link.label || ((_d = link.page) === null || _d === void 0 ? void 0 : _d.title) || ((_e = link.page) === null || _e === void 0 ? void 0 : _e.name) || link.name);
    }), header.showShare && React.createElement(My.UtilityButton, {
      menu: hasMenu && React.createElement(My.ShareMenu, {
        onItemClick: header.onShareButtonClick,
        ref: header.shareMenuRef
      }),
      isMenuVisible: header.isShareMenuVisible,
      isInverted: isInverted,
      iconComponent: ShareCircleIcon,
      variant: variant,
      onClick: header.onShareButtonClick
    }, t('Share')), IS_LANG_ENABLED && React.createElement(My.LangUtilityButton, {
      isInverted: isInverted,
      iconComponent: GlobeCircleIcon,
      variant: variant,
      menu: hasMenu && React.createElement(My.LangMenu, {
        ref: header.langMenuRef
      }),
      isMenuVisible: header.isLangMenuVisible,
      onClick: header.onLangButtonClick
    }, t(activeLang.iso.toUpperCase())), header.showLogin && React.createElement(My.UtilityButton, {
      isInverted: isInverted,
      iconComponent: PersonCircleIcon,
      variant: variant,
      onClick: function onClick() {
        navigate(platformUrl);
      }
    }, t(loginLabel)));
  };

  return React.createElement(My.Container, {
    ref: ref,
    _backgroundColor: variant !== "overlay" && backgroundColor,
    showOverlayGradient: variant === "overlay" && showOverlayGradient,
    className: cls.name(className),
    heightMobile: headerHeightMobile,
    heightTablet: headerHeightTablet,
    heightDesktop: headerHeightDesktop
  }, React.createElement(My.MenuBar, {
    isVisible: !map.isVisible && (modal.isVisible || isMenuBarVisible),
    isInverted: isInverted,
    utilityButtons: React.createElement(React.Fragment, null, headerButtonsVariant('default'), React.createElement(My.UtilityButton, {
      menu: pinnedNavigationMenu,
      isMenuVisible: isMenuBarVisible && header.isPinnedNavigationMenuVisible,
      isInverted: isInverted,
      iconComponent: MenuCircleIcon,
      variant: "icon",
      onClick: header.onPinnedMenuButtonClick
    }, t('Sections'))),
    menuButtons: menuButtons
  }), React.createElement(SliceLayout, {
    entity: sliceEntity,
    boundary: boundary
  }, header.isNavigationMenuVisible && React.createElement(My.NavigationMenuReveal, {
    showSidebar: true,
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onMenuButtonClick,
    ref: header.navigationMenuRef
  }, navigationMenu), React.createElement(My.Layout, null, React.createElement(My.Logo, __assign({
    sizeVariant: 'default'
  }, logoProps)), React.createElement(My.Body, null, React.createElement(My.UtilityButtons, null, headerButtonsVariant('pinned')), React.createElement(My.NavigationAndControls, {
    variant: variant
  }, React.createElement(My.Navigation, null, menu && ((_a = menu.items) === null || _a === void 0 ? void 0 : _a.map(function (item) {
    var _a;

    var hasChildren = item.children && !!item.children.length;
    var isDisclosed = hasChildren && header.disclosedMenuItem === item.id;
    var isActive = hasChildren ? includes((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (item) {
      return item.path;
    }), currentEntity && currentEntity.path) : trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/');
    var onClick = hasChildren ? function () {
      header.setDisclosedMenuItem(isDisclosed ? '' : item.id);
    } : null;
    return React.createElement(My.NavigationItem, {
      key: item.id
    }, React.createElement(My.MenuItemLink, {
      onClick: onClick,
      variant: 'header',
      isActive: isActive,
      isDisclosed: isDisclosed,
      showActiveBar: !isDisclosed,
      color: header.menuItemLinkColor,
      hoverColor: header.menuItemLinkHoverColor,
      activeColor: header.menuItemLinkActiveColor,
      icon: hasChildren && React.createElement(Icons.ChevronDownIcon, null),
      entity: item
    }), isDisclosed && React.createElement(My.NavigationItemChildren, {
      ref: header.navigationDisclosedItemRef
    }, item.children.map(function (child) {
      return React.createElement(My.NavigationItemChild, {
        key: child.id
      }, React.createElement(My.MenuItemSubLink, {
        onClick: function onClick() {
          navigate(child.path);
          header.hideDisclosedMenuItem();
        },
        color: header.menuItemLinkColor,
        isActive: trim(child.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(child.path, '/'),
        hoverColor: header.menuItemChildLinkHoverColor,
        activeColor: header.menuItemChildLinkInvertedActiveColor,
        entity: child
      }));
    })));
  }))), React.createElement(My.Controls, null, showSearch && React.createElement(My.SearchButton, null, React.createElement(My.Icon, null, React.createElement(SearchCircleIcon, null))))), React.createElement(My.MenuButtons, null, menuButtons)), header.showShare && header.isShareMenuVisible && React.createElement(My.ShareMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onShareButtonClick,
    ref: header.shareMenuRevealRef
  }, React.createElement(My.ShareMenu, {
    onItemClick: header.onShareButtonClick
  })), IS_LANG_ENABLED && header.isLangMenuVisible && React.createElement(My.LangMenuReveal, {
    variant: isMenuBarVisible ? 'bar' : 'default',
    onCloseClick: header.onLangButtonClick,
    ref: header.langMenuRevealRef
  }, React.createElement(My.LangMenu, {
    onItemClick: header.onLangButtonClick
  })))));
};
SiteHeaderLayout.defaultProps = SiteHeaderLayoutDefaultProps;
SiteHeaderLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79;